import axios from 'axios';
import env from '@/env';
const baseURL = `${env.api.baseUrl.token}?tenantDomain=${env.api.tenantDomain}`;
const { cK, cS } = env.api;

const instance = axios.create({
  baseURL,
  auth: {
    username: cK,
    password: cS,
  },
  headers: {
    'content-type': 'application/x-www-form-urlencoded',
  },
});

export default instance;
